import React from 'react';
import { Helmet } from '@plone/volto/helpers';
import config from '@plone/volto/registry';

// XXX: ideale sarebbe prenere plone.site_title da @site che dovrebbe già essere
//      ma per ora chiudiamo così, come è fatto praticamente ovunque
const AppExtras = () => {
  return <Helmet titleTemplate={`%s - ${config.settings.iovisit.siteHeadTitleName}`} />;
};

export default AppExtras;
